// The Zoom slider under a vue-advanced-cropper (CropPortrait.vue; CropImage.vue has the same
// logic inline): moving it zooms the image in or out by the change since the last position.

import {ref, watch} from "vue";

function getZoomFactor(delta) {
  const speed = 2;
  const amount = Math.min(Math.abs(delta) * speed, 0.5);
  if (amount <= 0) return 1;
  return delta > 0 ? 1 + amount : 1 / (1 + amount);
}

// cropper: the Cropper's ref; resetZoom() when the dialog opens again (no jump from the old value)
export function useCropperZoom(cropper) {
  const zoomValue = ref(0.5);
  const lastZoomValue = ref(0.5);
  watch(zoomValue, (next) => {
    const delta = Number(next) - Number(lastZoomValue.value);
    if (!Number.isFinite(delta) || delta === 0) return;
    lastZoomValue.value = Number(next);
    cropper.value?.zoom(getZoomFactor(delta));
  });
  function resetZoom() {
    lastZoomValue.value = zoomValue.value;
  }
  return {zoomValue, resetZoom};
}
